import {
  IReport,
  IReportCustomer,
  IReportManager,
  IReportRequestType,
  IReportUnit
} from '../interfaces/report.interface';

export class ReportDTO implements IReport {
  id!: string;

  status!: string;

  creationDate!: Date;

  finishDate!: Date;

  unit!: IReportUnit;

  requestType!: IReportRequestType;

  customer!: IReportCustomer;

  manager!: IReportManager;
}
